import { useRestApiHeaders } from 'business/contextProviders/useApiHeaders';
import { useTunnelPositionV1ControllerGet } from 'generated/apiComponents';
import { Module_Enum } from 'generated/graphql';

export const useGetTunnelPositionData = (constructionSiteId: string) => {
  const restHeaders = useRestApiHeaders(Module_Enum.QualityControl);

  const { data, error, isLoading, refetch } = useTunnelPositionV1ControllerGet({
    pathParams: {
      constructionSiteId,
    },
    headers: restHeaders,
  });

  return {
    data,
    isLoading,
    error,
    refetch,
  };
};
